import Vue from "vue";
import Router from "vue-router";
import VueGtag from "vue-gtag";
import cognito from "../plugins/cognito";
import { RepositoryFactory } from "../../src/api/RepositoryFactory";

import Top from "../pages/pc/top/Top";
import SpTop from "../pages/sp/top/Top";

import HowToJoin from "../pages/pc/howtojoin/HowToJoin";
import SpHowToJoin from "../pages/sp/howtojoin/HowToJoin";

import Event from "../pages/pc/event/detail/Event";
import SpEvent from "../pages/sp/event/detail/Event";

import Confirmation from "../pages/pc/confirmation/Confirmation";
import SpConfirmation from "../pages/sp/confirmation/Confirmation";

import NoticeDetail from "../pages/pc/notice/NoticeDetail";
import SpNoticeDetail from "../pages/sp/notice/NoticeDetail";

import Result from "../pages/pc/result/Result";
import SpResult from "../pages/sp/result/Result";

import Ranking from "../pages/pc/ranking/Ranking";
import SpRanking from "../pages/sp/ranking/Ranking";

import Runner from "../pages/pc/ranking/runner/Runner";
import SpRunner from "../pages/sp/ranking/runner/Runner";

import Question from "../pages/pc/faq/Question";
import SpQuestion from "../pages/sp/faq/Question";

import Privacy from "../pages/pc/privacy/Privacy";
import SpPrivacy from "../pages/sp/privacy/Privacy";

import Contact from "../pages/pc/contact/Contact";
import SpContact from "../pages/sp/contact/Contact";

import RunApp from "../pages/common/runapp/RunApp";

import Link from "../pages/pc/link/Link";
import SpLink from "../pages/sp/link/Link";

import Certificate from "../pages/pc/ranking/certificate/Certificate";
import SpCertificate from "../pages/sp/ranking/certificate/Certificate";

import Login from "../pages/pc/company/login/Login";
import SpLogin from "../pages/sp/company/login/Login";

import Summary from "../pages/pc/company/summary/Summary";
import SpSummary from "../pages/sp/company/summary/Summary";

import CompanyEvent from "../pages/pc/company/event/Event";
import SpCompanyEvent from "../pages/sp/company/event/Event";

import CompanyRanking from "../pages/pc/company/ranking/Ranking";
import SpCompanyRanking from "../pages/sp/company/ranking/Ranking";

import CompanyConfirmation from "../pages/pc/company/confirmation/Confirmation";
import SpCompanyConfirmation from "../pages/sp/company/confirmation/Confirmation";

import CompanyCertificate from "../pages/pc/company/certificate/Certificate";
import SpCompanyCertificate from "../pages/sp/company/certificate/Certificate";

import CompanyLink from "../pages/pc/company/link/Link";
import SpCompanyLink from "../pages/sp/company/link/Link";

import SpCompanyHowToJoin from "../pages/sp/company/howtojoin/HowToJoin";
import CompanyHowToJoin from "../pages/pc/company/howtojoin/HowToJoin";

import SpCompanyQuestion from "../pages/sp/company/faq/Question";
import CompanyQuestion from "../pages/pc/company/faq/Question";

Vue.use(Router);
Vue.use(VueGtag, {
  config: {
    id: process.env.GA_ID,
  },
});

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: window.innerWidth <= 1024 ? SpTop : Top,
    },
    {
      path: "/howtojoin",
      component: window.innerWidth <= 1024 ? SpHowToJoin : HowToJoin,
    },
    {
      path: "/confirmation",
      component: window.innerWidth <= 1024 ? SpConfirmation : Confirmation,
    },
    {
      path: "/notice",
      component: window.innerWidth <= 1024 ? SpNoticeDetail : NoticeDetail,
    },
    {
      path: "/result",
      component: window.innerWidth <= 1024 ? SpResult : Result,
    },
    {
      path: "/ranking",
      component: window.innerWidth <= 1024 ? SpRanking : Ranking,
    },
    {
      path: "/question",
      component: window.innerWidth <= 1024 ? SpQuestion : Question,
    },
    {
      path: "/privacy",
      component: window.innerWidth <= 1024 ? SpPrivacy : Privacy,
    },
    {
      path: "/contact",
      component: window.innerWidth <= 1024 ? SpContact : Contact,
    },
    {
      path: "/runapp",
      component: RunApp,
    },
    {
      path: "/link",
      component: window.innerWidth <= 1024 ? SpLink : Link,
    },
    {
      path: "/ranking/certificate",
      component:
        /[ \\(]iP/.test(navigator.userAgent) || window.innerWidth <= 1024
          ? SpCertificate
          : Certificate,
    },
    {
      path: "/ranking/runner",
      component: window.innerWidth <= 1024 ? SpRunner : Runner,
    },
    {
      path: "/event/:event",
      component: window.innerWidth <= 1024 ? SpEvent : Event,
    },
    {
      path: "/en",
      component: window.innerWidth <= 1024 ? SpTop : Top,
    },
    {
      path: "/en/notice",
      component: window.innerWidth <= 1024 ? SpNoticeDetail : NoticeDetail,
    },
    {
      path: "/en/howtojoin",
      component: window.innerWidth <= 1024 ? SpHowToJoin : HowToJoin,
    },
    {
      path: "/en/result",
      component: window.innerWidth <= 1024 ? SpResult : Result,
    },
    {
      path: "/en/question",
      component: window.innerWidth <= 1024 ? SpQuestion : Question,
    },
    {
      path: "/en/privacy",
      component: window.innerWidth <= 1024 ? SpPrivacy : Privacy,
    },
    {
      path: "/en/contact",
      component: window.innerWidth <= 1024 ? SpContact : Contact,
    },
    {
      path: "/en/runapp",
      component: RunApp,
    },
    {
      path: "/en/link",
      component: window.innerWidth <= 1024 ? SpLink : Link,
    },
    {
      path: "/en/confirmation",
      component: window.innerWidth <= 1024 ? SpConfirmation : Confirmation,
    },
    {
      path: "/en/ranking",
      component: window.innerWidth <= 1024 ? SpRanking : Ranking,
    },
    {
      path: "/en/ranking/runner",
      component: window.innerWidth <= 1024 ? SpRunner : Runner,
    },
    {
      path: "/en/ranking/certificate",
      component:
        /[ \\(]iP/.test(navigator.userAgent) || window.innerWidth <= 1024
          ? SpCertificate
          : Certificate,
    },
    {
      path: "/en/event/:event",
      component: window.innerWidth <= 1024 ? SpEvent : Event,
    },
    {
      path: "/company/login",
      component: window.innerWidth <= 1024 ? SpLogin : Login,
      meta: { notRequiredAuth: true },
    },
    {
      path: "/company/summary",
      component: window.innerWidth <= 1024 ? SpSummary : Summary,
      meta: { requiredAuth: true },
    },
    {
      path: "/company/ranking",
      component: window.innerWidth <= 1024 ? SpCompanyRanking : CompanyRanking,
      meta: { requiredAuth: true },
    },
    {
      path: "/company/confirmation",
      component:
        window.innerWidth <= 1024 ? SpCompanyConfirmation : CompanyConfirmation,
      meta: { requiredAuth: true },
    },
    {
      path: "/company/link",
      component: window.innerWidth <= 1024 ? SpCompanyLink : CompanyLink,
    },
    {
      path: "/company/howtojoin",
      component:
        window.innerWidth <= 1024 ? SpCompanyHowToJoin : CompanyHowToJoin,
    },
    {
      path: "/company/question",
      component:
        window.innerWidth <= 1024 ? SpCompanyQuestion : CompanyQuestion,
    },
    {
      path: "/company/ranking/runner",
      component: window.innerWidth <= 1024 ? SpRunner : Runner,
      meta: { requiredAuth: true },
    },
    {
      path: "/company/ranking/certificate",
      component:
        /[ \\(]iP/.test(navigator.userAgent) || window.innerWidth <= 1024
          ? SpCompanyCertificate
          : CompanyCertificate,
      meta: { requiredAuth: true },
    },
    {
      path: "/company/event/:event",
      component: window.innerWidth <= 1024 ? SpCompanyEvent : CompanyEvent,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/login",
      component: window.innerWidth <= 1024 ? SpLogin : Login,
      meta: { notRequiredAuth: true },
    },
    {
      path: "/en/company/summary",
      component: window.innerWidth <= 1024 ? SpSummary : Summary,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/ranking",
      component: window.innerWidth <= 1024 ? SpCompanyRanking : CompanyRanking,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/confirmation",
      component:
        window.innerWidth <= 1024 ? SpCompanyConfirmation : CompanyConfirmation,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/link",
      component: window.innerWidth <= 1024 ? SpCompanyLink : CompanyLink,
    },
    {
      path: "/en/company/howtojoin",
      component:
        window.innerWidth <= 1024 ? SpCompanyHowToJoin : CompanyHowToJoin,
    },
    {
      path: "/en/company/question",
      component:
        window.innerWidth <= 1024 ? SpCompanyQuestion : CompanyQuestion,
    },
    {
      path: "/en/company/ranking/runner",
      component: window.innerWidth <= 1024 ? SpRunner : Runner,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/ranking/certificate",
      component:
        /[ \\(]iP/.test(navigator.userAgent) || window.innerWidth <= 1024
          ? SpCompanyCertificate
          : CompanyCertificate,
      meta: { requiredAuth: true },
    },
    {
      path: "/en/company/event/:event",
      component: window.innerWidth <= 1024 ? SpCompanyEvent : CompanyEvent,
      meta: { requiredAuth: true },
    },
    {
      path: "/event/0000000001/confirmation",
      redirect: "/confirmation",
    },
    {
      path: "/*",
      redirect: "/",
    },
  ],

  /**
   * App.vueでフワッと演出する際、遷移元のページ位置がTOPに戻ってしまうのでsetTimeoutで制御
   */
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({ x: 0, y: 0 });
        }
      }, 400);
    });
  },
});

router.beforeResolve((to, from, next) => {
  cognito
    .isAuthenticated()
    .then(() => {
      if (to.matched.some((record) => record.meta.notRequiredAuth)) {
        next({ path: "/company/summary" });
      }
    })
    .catch(() => {
      const path = window.location.pathname;
      const isEnglish = path.split("/")[1] === "en";
      const langPath = isEnglish ? "/en" : "";
      if (
        to.matched.some((record) => record.path === langPath + "/company/ranking") ||
        to.matched.some((record) => record.path === langPath + "/company/ranking/certificate") ||
        to.matched.some((record) => record.path === langPath + "/company/confirmation")
      ) {
        // チーム対抗ランキングページの場合は、オープンイベントであればログイン不要とする
        (async () => {
          const EventRepository = RepositoryFactory.get("event");
          const params = {
            code: new URLSearchParams(window.location.search).get("event"),
            lang: isEnglish ? "en" : "ja",
            is_company_event: true,
          };
          await EventRepository.getEvent(params).catch((e) => {
            next({ path: "/company/login" });
          });
        })();
      } else if (to.matched.some((record) => record.meta.requiredAuth)) {
        next({ path: "/company/login" });
      }
    });
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js